import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import Stats from 'view/stats';

const StatsPage = () => {
	return (
		<PageTemplate>
			<Stats />
		</PageTemplate>
	);
};

export default StatsPage;

 